import { BlockModule } from '@site-builder/common/src/types/block/common/block-module';
import { ComponentTypes } from '@site-builder/common/src/types/block/common/component-types';

export enum PlaceTypes {
  HEADER = BlockModule.HEADER,
  STORE = BlockModule.STORE,
  CUSTOM_BUTTON = ComponentTypes.CUSTOM_BUTTON,
}

interface CanShowCartProps {
  isNewScheme: boolean;
  enableCart: boolean;
  placeType: PlaceTypes;
  isMultipage?: boolean;
  isLandingIncludeStoreBlock?: boolean;
}

export const canShowCart = ({
  isNewScheme,
  enableCart,
  isMultipage = false,
  isLandingIncludeStoreBlock = false,
  placeType,
}: CanShowCartProps): boolean => {
  return (
    isNewScheme &&
    enableCart &&
    (placeType === PlaceTypes.STORE ||
      (placeType === PlaceTypes.HEADER &&
        (isLandingIncludeStoreBlock || isMultipage)) ||
      (placeType === PlaceTypes.CUSTOM_BUTTON && isMultipage))
  );
};
